import React from 'react';
import { getStaticUrl } from '../../../../utils/img';

const Gold = () => (
  <img src={getStaticUrl('web/v1/img/member_center_circle_dollar.svg')} />
);

export default Gold;
